import { api, AxiosRequestConfigWithMetadata } from '../../services/api.service'

export type AppSettingsObject = Record<string, string | number | boolean>

class AppSettingsApi {
  async getAppSettings(): Promise<AppSettingsObject> {
    const apiCall = await api.get('/api/app-settings', {
      functionName: 'appSettings_getAppSettings'
    } as AxiosRequestConfigWithMetadata)
    return apiCall.data
  }
}

export const appSettingsApi = new AppSettingsApi()
